import React from 'react';

// Material UI
import { Paper, Typography, Box, Grid, Divider } from "@mui/material"

// Components
import Spinner from '../../../../components/spinner';
import Info from '../../../Archings/totals/Info';
import Total from '../../../Archings/totals/Total';

const ClosedCashType = ({ title, cashType, totals, detail, onInputChange, loading, viewMovements }) => (
    <Box component={Paper} padding={2}>
        <Grid container spacing={1}>
            <Grid size={12}>
                <Typography variant='h5'>
                    <strong>{title}</strong>
                </Typography>
            </Grid>
            <Grid size={12}>
                <Info
                    color
                    isTitles
                    highlight
                    actions
                    ingress='Ingresos'
                    egress='Egresos'
                    total='Total'
                    real='Real'
                    diff='Diferencia'
                />
            </Grid>
            {loading && <Grid size={12}> <Spinner /> </Grid>}
            {
                totals &&
                <Grid size={12}>
                    <Total
                        diff
                        cashType={cashType}
                        totals={totals}
                        detail={detail}
                        onInputChange={onInputChange}
                        viewMovements={() => viewMovements({ cashType })}
                    />
                </Grid>
            }
            <Grid size={12}>
                <Divider />
            </Grid>
            <Grid size={12}>
                <Info
                    actions
                    highlight
                    description="Total:"
                    ingress={totals?.[cashType]?.ingress || 0}
                    egress={totals?.[cashType]?.egress || 0}
                    total={totals?.[cashType]?.total || 0}
                    diff={Number(totals?.[cashType]?.total || 0) - Number(detail?.[cashType]?.real || 0)}
                    real={Number(detail?.[cashType]?.real || 0)}
                />
            </Grid>
        </Grid>
    </Box>
)

export default ClosedCashType;